import React from "react"

export const WertungDerAngeboteIcon = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size * 36.8 : 36.8}
      height={size ? size * 34 : 34}
      style={{
        overflow: "visible",
        enableBackground: "new 0 0 36.8 34",
      }}
      xmlSpace="preserve"
    >
      <style>
        {
          ".st0{fill:#e5edf0}.st1,.st3{fill:none;stroke:#b3cbd4;stroke-width:1.8}.st3{stroke:#035470}"
        }
      </style>
      <path className="st0" d="M4.9 26h27v8h-27zM4.9 0h27v8h-27z" />
      <path className="st1" d="M12.9 30h14M12.9 4h14M9.9 30h2M9.9 4h2" />
      <path
        style={{
          fill: "#ffd62e",
        }}
        d="M2.9 11h31v12h-31z"
      />
      <path className="st3" d="M12.9 17h14M7.9 17h2M.9 9h35v16H.9z" />
    </svg>
  )
}
